"use client";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCcpqM2v5ERW93cw0k7VZJgi4ykyvA-Nlc",
  authDomain: "shree-kamdhenu-furniture.firebaseapp.com",
  projectId: "shree-kamdhenu-furniture",
  storageBucket: "shree-kamdhenu-furniture.firebasestorage.app",
  messagingSenderId: "490411472661",
  appId: "1:490411472661:web:d8fab053b3a3616b42db1c",
  measurementId: "G-ERGTQGBFLS"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth };
